// import Vue from 'vue'
export default [
  {
    path: '/',
    name: 'login',
    meta: {
      requireAuth: false
    },
    component: function () {
      return import('@/views/auth')
    }
  }
]
